import ChatbotSection from '../components/Sections/ChatbotSection';

const Chatbot = ({ }) => {
    return (
        <main>
            <ChatbotSection 
                userType={'employer'}
                name={'Harmony'} 
                title={(<span><span className="font-normal">Have Questions? </span><br />Chat with Harmony, Our Assistant Wellbeing Officer</span>)} 
                description={(
                    <span>Harmony is here to help you get the most out of OptiMe.<br />
                    Ask about platform features, wellbeing metrics, employee engagement insights, or how to support your team's growth.<br />
                    Start by typing your question, or ask Harmony to walk you through your latest wellbeing trends.</span>)
                } 
            />
     
        </main>
    )
};

export default Chatbot;
